"use client";

import {
  ProgramsListingView,
  type ProgramSummary,
} from "@/components/programs/ProgramsDarkView";

interface ProgramsPageViewProps {
  programs: ProgramSummary[];
}

export function ProgramsPageView({ programs }: ProgramsPageViewProps) {
  return <ProgramsListingView programs={programs} />;
}
